var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcos02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166.8 166.8",
    style: {
      enableBackground: "new 0 0 166.8 166.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A30039;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,57.1H112c2.4,0,4.4,2.4,4.4,4.4V134c0,2.4-2,4.4-4.4,4.4H32.9c-2.4,0-4.4-2.4-4.4-4.4V61.6 C28.5,59.1,30.5,57.1,32.9,57.1L32.9,57.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.5,39.5h-81v8.8h76.6v70h8.8V43.9c0-1.2-0.5-2.3-1.3-3.1C131.8,40,130.7,39.5,129.5,39.5L129.5,39.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcos02);
export default __webpack_public_path__ + "static/media/icos-02.6cc1098c.svg";
export { ForwardRef as ReactComponent };